import React from "react";
import { Box } from "@mui/material";
import LoadingPlaceholderBlock from "components/common/LoadingPlaceholderBlock";
import { styles } from "./HighlightCard";

export default function HighlightLoader() {
  return (
    <Box sx={styles.card}>
      <Box sx={styles.highlight}>
          <LoadingPlaceholderBlock
              width={"100px"}
              height={"18px"}
              borderRadius={"6px"}
              backgroundColor={"#EFEAE5"}
          />
      </Box>

      <Box
        sx={{
          ...styles.summary,
          display: "grid",
          gap: "5px",
          marginTop: "13px",
        }}
      >
        <LoadingPlaceholderBlock
          width={"100%"}
          height={"11px"}
          borderRadius={"6px"}
          backgroundColor={"#EFEAE5"}
        />
        <LoadingPlaceholderBlock
          width={"100%"}
          height={"11px"}
          borderRadius={"6px"}
          backgroundColor={"#EFEAE5"}
        />
        <LoadingPlaceholderBlock
          width={"70%"}
          height={"11px"}
          borderRadius={"6px"}
          backgroundColor={"#EFEAE5"}
        />
      </Box>
    </Box>
  );
}
